<template>
    <div class="basicInfo">
        <el-dialog title="志愿者详情" :visible="true" width="65%" class="detailDialog" @close="onCancel">
            <div class="dialog-box">
                <el-tabs type="border-card" v-model="activeName" @tab-click="tabChange">
                    <el-tab-pane name="basicInfo" label="基本信息">
                        <div class="box-basicInfo">
                            <el-row class="basicInfo-item">
                                <el-col :span="4" class="item-label">姓名：</el-col>
                                <el-col :span="18" class="item-value">{{volunteerApply.Name}}</el-col>
                            </el-row> 
                            <el-row class="basicInfo-item">
                                <el-col :span="4" class="item-label">民族：</el-col>
                                <el-col :span="18" class="item-value">{{volunteerApply.Nation}}</el-col>
                            </el-row> 
                            <el-row class="basicInfo-item">
                                <el-col :span="4" class="item-label">学历：</el-col>
                                <el-col :span="18" class="item-value">{{volunteerApply.Education}}</el-col>
                            </el-row> 
                            <el-row class="basicInfo-item">
                                <el-col :span="4" class="item-label">电子邮箱：</el-col>
                                <el-col :span="18" class="item-value">{{volunteerApply.Email}}</el-col>
                            </el-row> 
                            <el-row class="basicInfo-item">
                                <el-col :span="4" class="item-label">工作单位：</el-col>
                                <el-col :span="18" class="item-value">{{volunteerApply.WorkUnit}}</el-col>
                            </el-row> 
                            <el-row class="basicInfo-item">
                                <el-col :span="4" class="item-label">特长：</el-col>
                                <el-col :span="18" class="item-value">{{volunteerApply.Specialty}}</el-col>
                            </el-row> 
                            <el-row class="basicInfo-item">
                                <el-col :span="4" class="item-label">性别：</el-col>
                                <el-col :span="18" class="item-value">{{volunteerApply.Sex === 0?'女':'男'}}</el-col>
                            </el-row> 
                            <el-row class="basicInfo-item">
                                <el-col :span="4" class="item-label">籍贯：</el-col>
                                <el-col :span="18" class="item-value">{{volunteerApply.NativePlace}}</el-col>
                            </el-row> 
                            <el-row class="basicInfo-item">
                                <el-col :span="4" class="item-label">电话：</el-col>
                                <el-col :span="18" class="item-value">{{volunteerApply.Mobile}}</el-col>
                            </el-row> 
                            <el-row class="basicInfo-item">
                                <el-col :span="4" class="item-label">身份证号：</el-col>
                                <el-col :span="18" class="item-value">{{volunteerApply.IdentityNo}}</el-col>
                            </el-row> 
                            <el-row class="basicInfo-item">
                                <el-col :span="4" class="item-label">通信地址：</el-col>
                                <el-col :span="18" class="item-value">{{volunteerApply.Address}}</el-col>
                            </el-row> 
                            <el-row class="basicInfo-item">
                                <el-col :span="4" class="item-label">居住属性：</el-col>
                                <el-col :span="18" class="item-value">{{volunteerApply.ResidentialProperty === 0?'常驻':'暂住'}}</el-col>
                            </el-row> 
                            <div class="basicInfo-title">
                                <!-- <div class="basicInfo-bgc" /> -->
                                <h4 style="font-weight:bold">加入无偿献血服务队</h4>
                            </div>
                            <el-row class="basicInfo-item">
                                <el-col :span="4" class="item-label">血型：</el-col>
                                <el-col :span="18" class="item-value">{{volunteerApply.BloodType}}</el-col>
                            </el-row>
                            <el-row class="basicInfo-item">
                                <el-col :span="4" class="item-label">献血次数：</el-col>
                                <el-col :span="18" class="item-value">{{volunteerApply.BloodDonationNumber}}</el-col>
                            </el-row>
                            <el-row class="basicInfo-item">
                                <el-col :span="4" class="item-label">献血量：</el-col>
                                <el-col :span="18" class="item-value">{{volunteerApply.BloodDonationCapacity}}ml</el-col>
                            </el-row> 
                            <div class="basicInfo-title">
                                <!-- <div class="basicInfo-bgc" /> -->
                                <h4 style="font-weight:bold">参加志愿队名称</h4>
                            </div>
                            <el-row class="basicInfo-item" v-for="(item,a) in volunteerTeam" :key="'team' + a">
                                <el-col :span="4" class="item-label"><div class="radioBox">&#12288;</div></el-col>
                                <el-col :span="18" class="item-value" v-if="(item!== '其他')">{{item}}</el-col>
                                <el-col :span="18" class="item-value" v-else>{{item}}({{volunteerApply.CorpOther}})</el-col>
                            </el-row> 
                            <div class="basicInfo-title">
                                <!-- <div class="basicInfo-bgc" /> -->
                                <h4 style="font-weight:bold">志愿服务时间</h4>
                            </div>
                            <el-row class="service">
                                <el-col :span="3" class="border-default">时间</el-col>
                                <el-col :span="3" v-for="(item,b) in week" :key="'time' + b" class="border-left">{{item}}</el-col>
                            </el-row>
                            <el-row class="service service-margin">
                                <el-col :span="3" class="border-default">上午</el-col>
                                <el-col :span="3" v-for="(item,c) in week" :key="'morning' + c" class="border-left">{{showTicks(0,item,volunteerApply.ApplyVolunteerService)}}</el-col>
                            </el-row>
                            <el-row class="service service-margin">
                                <el-col :span="3" class="border-default">下午</el-col>
                                <el-col :span="3" v-for="(item,d) in week" :key="'noon' + d" class="border-left">{{showTicks(1,item,volunteerApply.ApplyVolunteerService)}}</el-col>
                            </el-row>
                            <el-row class="service service-margin">
                                <el-col :span="3" class="border-default">晚上</el-col>
                                <el-col :span="3" v-for="(item,e) in week" :key="'night' + e" class="border-left">{{showTicks(2,item,volunteerApply.ApplyVolunteerService)}}</el-col>
                            </el-row>
                            <div style="padding-top:10px;padding-left:20px;">
                                <p>一周可参加志愿服务时间:{{volunteerApply.TimeForWeek}}</p>
                            </div>
                            <div class="basicInfo-title">
                                <!-- <div class="basicInfo-bgc" /> -->
                                <h4 style="font-weight:bold">红十字志愿者誓词</h4>
                            </div>
                            <el-row class="basicInfo-item">
                                <p>{{volunteerApply.VolunteerPromise}}</p>
                            </el-row>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane name="serviceRecord" label="服务记录">
                        <el-table :data="signList" v-loading="loading" style="width: 100%" border :max-height="tableMaxHeight()">
                            <el-table-column prop="Title" label="活动名称" show-overflow-tooltip  />
                            <el-table-column prop="Address" label="活动地点" show-overflow-tooltip  />
                            <el-table-column prop="ActivityStartTime" label="活动开始时间" width="140">
                                <template slot-scope="scope">
                                    {{ (scope.row.ActivityStartTime * 1000) | formatDate }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="ActivityEndTime" label="活动结束时间" width="140">
                                <template slot-scope="scope">
                                    {{ (scope.row.ActivityEndTime * 1000) | formatDate }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="SignStartTime" label="签到状态" width="80">
                                <template slot-scope="scope">
                                    {{ scope.row.SignStartTime === null?'--':'已签到' }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="SignEndTime" label="签退状态" width="80">
                                <template slot-scope="scope">
                                    {{ scope.row.SignEndTime === null?'--':'已签退' }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="Duration" label="工时">
                                <template slot-scope="scope">
                                    {{ scope.row.Duration | duration }}
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="pagination-wapper">
                            <OfPagination
                                :total="signTotal"
                                :pageSize="request.pageSize"
                                :currentPage="request.pageIndex"
                                @onSizeChange="handleSizeChange"
                                @onCurrentChange="handleCurrentChange"
                            ></OfPagination>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import api from "@/modules/zjrc/api";
    import OfPagination from "@/components/controls/of_pagination/of_pagination";
export default {
    name: 'basicInfo',
    props:{
        userId:{
            type: String,
            default: ''
        }
    },
    data(){
        return{
            request: {
                pageIndex: 1,
                pageSize: 15,
                searchKey: ''
            },
            loading: false,
            dialogVisible: true,
            activeName: 'basicInfo',
            volunteerApply: {},
            volunteerTeam: [],
            week: ['星期一','星期二','星期三','星期四','星期五','星期六','星期日'],
            promiseArry: [],
            signList: [],
            signTotal: 0,
        }
    },
    components:{
        OfPagination
    },
    mounted(){
        const vm = this
        vm.getBasicInfo()
    },
    methods:{
        onCancel(){
            const vm = this
            vm.$emit("onCancel")
        },
        getSignRecord(){
            const vm = this
            let param = vm.request
            param.userId = vm.userId
            api.QuerySignByUserId(param).then(res=>{
                if(res.data.Code === 0){
                    vm.signList = res.data.Data.rows
                    vm.signTotal = res.data.Data.total
                }
            })
        },
        getBasicInfo(){
            const vm = this
            const param = {userId: vm.userId}
            api.QueryApplyVolunteerByUserId(param).then(res=>{
                if(res.data.Code === 0){
                    vm.volunteerApply = res.data.Data
                    if(vm.volunteerApply.VolunteerCorps && vm.volunteerApply.VolunteerCorps !== ''){
                        vm.volunteerTeam = JSON.parse(vm.volunteerApply.VolunteerCorps)
                    }
                }
            })
        },
        showTicks(time,week,applyVolunteerService){
            const vm = this
            const morning = [1 , 3 , 5 , 7]
            const noon = [2 , 3 , 6 , 7]
            const night = [4 , 5 , 6 , 7]
            let now = []
            if(time === 0){
                now = morning
            }else if(time === 1){
                now = noon
            }else{
                now = night
            }
            if(applyVolunteerService){
                switch(week){
                    case '星期一' :
                        return vm.getTicks(applyVolunteerService.Monday,now)
                    case '星期二' :
                        return vm.getTicks(applyVolunteerService.Tuesday,now)
                    case '星期三' :
                        return vm.getTicks(applyVolunteerService.Wednesday,now)
                    case '星期四' :
                        return vm.getTicks(applyVolunteerService.Thursday,now)
                    case '星期五' :
                        return vm.getTicks(applyVolunteerService.Friday,now)
                    case '星期六' :
                        return vm.getTicks(applyVolunteerService.Saturday,now)
                    case '星期日' :
                        return vm.getTicks(applyVolunteerService.Sunday,now)
                }
            }
        },
        getTicks(value,timeArry){
            if(timeArry.includes(value)){
                return '√'
            }else{
                return ''
            }
        },
        tabChange(tab){
            const vm = this
            if(tab.name === 'basicInfo'){
                vm.getBasicInfo()
            }else{
                vm.getSignRecord()
            }
        },
        handleCurrentChange(pageIndex){
            const vm = this
            if(vm.total > vm.request.pageSize){
                vm.getSignRecord(pageIndex)
            }
        },
        handleSizeChange(pageSize){
            const vm = this
            vm.request.pageSize = pageSize
            vm.getSignRecord(1)
        },
        //表格高度
        tableMaxHeight() {
            var clientHeight = window.innerHeight;
            var tableMaxHeight = 0;
            if (clientHeight && clientHeight !== undefined) {
                tableMaxHeight = clientHeight - 363;
            }
            return tableMaxHeight;
        },
    }
}
</script>
<style lang="scss" scoped>
.basicInfo{
        .detailDialog{
        .dialog-box{
            .box-basicInfo{
                max-height: 63vh;
                overflow-y: auto;
                padding: 15px;
                .basicInfo-item{
                    border-bottom: 1px dashed rgb(201, 198, 198);
                    padding: 5px;
                    .item-label{
                        text-align: right;
                        .radioBox{
                            width: 10px;
                            height: 10px;
                            border-radius: 10px;
                            background-color: red;
                            float: right;
                            margin: 5px;
                            line-height: 20px;
                        }
                    }
                }
                .basicInfo-promise{
                    padding: 5px 20px;
                }
                .basicInfo-title{
                    margin:5px;
                    padding:5px;
                    background-color:#fff;
                    .basicInfo-bgc{
                        float: left;
                        background-color: red;
                        width: 5px;
                        height: 19.2px;
                        margin-right: 5px;
                        margin-top: 10px;
                    }
                }
                .service{
                    border: 1px solid rgb(219, 218, 218);
                    margin: 10px 15px 0px;
                    .border-left{
                        padding: 5px;
                        border-left: 1px solid rgb(219, 218, 218);
                        text-align: center;
                        height: 30px;
                    }
                    .border-default{
                        padding: 5px;
                        text-align: center;
                        height: 30px;
                    }
                }
                .service-margin{
                    margin: 0px 15px;
                    border-top: none;
                }
            }
        }
    }
}
</style>